import React, {FC, ReactNode} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"

import {Container, StyledH3} from "./styled"

interface Props {
  id?: string,
  children?: ReactNode,
  additionalElement?: ReactNode
}

const NoExist: FC<Props> = (props) => {
  const {children, additionalElement} = props
  const idNamespace = id("no-exist", props)

  return (
    <Container id={idNamespace}>
      <StyledH3>{children || <FormattedMessage id="platform.layout.noExist.defaultText" />}</StyledH3>
      {additionalElement}
    </Container>
  )
}

export default NoExist
